// @flow
import React from 'react';
import Pendo from '../../Pendo';
import useSelfEnrollment from '../../../hooks/useSelfEnrollment';

const Tracking = () => {
  const { patientData, entityData } = useSelfEnrollment();

  const currentPatient = {
    patientId: patientData?.patientId,
    patientEntityId: entityData?.entityId,
  };

  return <Pendo type="patient" currentPatient={currentPatient} />;
};

export default Tracking;
